const l = (e, t) => e.data[t], a = (e, t) => (e.data[t].value = e.newValue, !0);
export {
  l as labelCellValueGetter,
  a as labelCellValueSetter
};
//# sourceMappingURL=index.es572.js.map
